var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4656 15.6544C13.6308 15.7303 13.817 15.7476 13.9934 15.7036C14.1697 15.6595 14.3259 15.5567 14.436 15.412L14.72 15.04C14.869 14.8413 15.0623 14.68 15.2845 14.5689C15.5066 14.4578 15.7516 14.4 16 14.4H18.4C18.8243 14.4 19.2313 14.5686 19.5314 14.8686C19.8314 15.1687 20 15.5757 20 16V18.4C20 18.8243 19.8314 19.2313 19.5314 19.5314C19.2313 19.8314 18.8243 20 18.4 20C14.5809 20 10.9182 18.4829 8.21766 15.7823C5.51714 13.0818 4 9.41912 4 5.6C4 5.17565 4.16857 4.76869 4.46863 4.46863C4.76869 4.16857 5.17565 4 5.6 4H8C8.42435 4 8.83131 4.16857 9.13137 4.46863C9.43143 4.76869 9.6 5.17565 9.6 5.6V8C9.6 8.24839 9.54217 8.49337 9.43108 8.71554C9.32 8.93771 9.15871 9.13097 8.96 9.28L8.5856 9.5608C8.43873 9.67294 8.33522 9.83247 8.29263 10.0123C8.25005 10.1921 8.27103 10.3811 8.352 10.5472C9.44534 12.7679 11.2435 14.5638 13.4656 15.6544Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "phone.fb593a559b0da0f245dcf4ca5efa6d77.svg";